export class MessageValidation {
    constructor(message) {
        this.message = message || '';
    }
}
